import { parseISO } from 'date-fns';

import type { DateRangeValueType } from 'types';

export const rangeValueToDateObj = (value: DateRangeValueType) =>
  value === null ? null : parseISO(value);
